<template>
  <div id="BillDetail">
    <div class="open-table-search">
      <div class="open-table-search-list">
        <span class="search-text">{{ $t('发货时间') }}</span>
        <es-date-picker
          class="search-fun"
          v-model="search.startTime"
          type="month"
          :placeholder="$t(`选择日期`)"
          value-format="yyyy-MM"
          :picker-options="pickerOptions"
        >
        </es-date-picker>
      </div>
      <div class="open-table-search-list">
        <span class="search-text">{{ $t('产品名称') }}</span>
        <es-select filterable v-model="search.proId" :placeholder="$t(`请选择`)" @change="changePro()" class="search-fun">
          <es-option v-for="(item, index) in proList" :key="index" :label="item.productName" :value="item.productId"></es-option>
        </es-select>
      </div>
      <div class="open-table-search-list">
        <es-select v-model="search.orderId" :placeholder="$t(`请选择`)" class="search-fun">
          <es-option v-for="(key, value) in orderListFilterProduct" :key="value" :label="key.showId" :value="key.id"></es-option>
        </es-select>
      </div>
      <div class="open-table-search-list search-submit">
        <es-button @click="searchList()" type="primary" :loading="loadingButton">{{ $t('查询') }}</es-button>
        <es-button variant="outline" @click="clear()">{{ $t('清空') }}</es-button>
      </div>
    </div>

    <divided />
    <div class="common-body">
      <div class="tip">
        {{ realTime }} &nbsp;{{
          $t('共收货{amount}个', {
            amount,
          })
        }}<es-button @click="recordExport" :disabled="deliveryList.length == 0" class="tip-button" variant="outline">{{
          $t('导出发货记录')
        }}</es-button>
      </div>
      <div class="table">
        <es-row class="table-title">
          <es-col :span="4">{{ $t('发货ID') }}</es-col>
          <es-col :span="4">{{ $t('发货时间') }}</es-col>
          <es-col :span="4">{{ $t('订单号') }}</es-col>
          <es-col :span="4">{{ $t('产品名称') }}</es-col>
          <es-col :span="2">{{ $t('发货状态') }}</es-col>
          <es-col :span="4">{{ $t('发件人') }}</es-col>
          <es-col :span="2">{{ $t('发件数量') }}</es-col>
          <es-col :span="4">{{ $t('收件人') }}</es-col>
        </es-row>
        <es-row class="table-main" v-for="(item, index) in deliveryList" :key="index">
          <es-col :span="4">{{ item.code }}</es-col>
          <es-col :span="4">{{ item.deliveryTime }}</es-col>
          <es-col :span="4">{{ item.showId }}</es-col>
          <es-col :span="4">{{ item.productName }}</es-col>
          <es-col :span="2">{{ getStatus(item.status)[0].label }}</es-col>
          <es-col :span="4">{{ item.companyName }}</es-col>
          <es-col :span="2">{{ item.totalNum }}</es-col>
          <es-col :span="4">{{ item.receiverName }}</es-col>
        </es-row>
        <es-row class="noData" v-show="deliveryList.length === 0" style="height: 200px">
          <es-empty
            style="margin: 25px; color: #999; line-height: 40px"
            :description="$t(`暂无更多数据`)"
            image="data:image/png;base64,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"
            :image-size="64"
          ></es-empty> </es-row
        ><!-- 分页 -->

        <es-pagination
          class="page"
          @current-change="currentChange"
          :current-page.sync="currentPage"
          layout="prev, pager, next, jumper"
          v-show="deliveryList.length > 0"
          :total="total"
        >
        </es-pagination>

        <es-dialog :title="$t(`导出发货记录`)" :visible.sync="dialogVisible" width="30%">
          <es-row class="dialogRow">
            <div class="load" v-show="status == 0">
              <img src="@/assets/common/load.png" />
              <span> &nbsp;{{ $t('{month}月', { month: time }) }}{{ $t('发货记录生成中，请稍等…') }} </span>
            </div>
            <div class="load" v-show="status == 1">
              <div v-for="(item, index) in urls" :key="index">
                <span> {{ item.time | formatUtc }}{{ $t('发起的发货记录导出请求已经生成完毕。') }}</span>
                <es-button type="text" class="downLoadBtn" @click="downLoad(item.url)">{{ $t('下载') }}</es-button>
              </div>
            </div>
          </es-row>
          <span slot="footer">
            <es-button type="primary" @click="dialogVisible = false">{{ $t('关闭') }}</es-button>
          </span>
        </es-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { $t } from '@/locales'

import divided from '../../components/divided'
import { mapState } from 'vuex'
export default {
  components: {
    divided,
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
    span() {
      return screen.width <= 1440 ? 8 : 6
    },
    orderListFilterProduct() {
      return this.orderList.filter(key => key.showId && key.productId === this.search.proId)
    },
  },
  data() {
    let startTime
    if (this.$route.query.year && this.$route.query.month) {
      startTime = `${this.$route.query.year}-${this.$route.query.month}`
    } else {
      const date = new Date()
      startTime = `${date.getFullYear()}-${date.getMonth() + 1}`
    }

    return {
      dialogVisible: false,
      // 选择日期
      pickerOptions: {
        disabledDate(time) {
          const date = new Date()

          return time.getTime() < date.getTime() - 365 * 3600 * 1000 * 24 * 2
        },
      },
      time: '', // 导出记录时间
      clock: null,
      exportLoading: false,
      currentPage: 1,
      realTime: '',
      loadingButton: false,
      search: {
        startTime,
        proId: Number(this.$route.query.proId) || '',
        orderId: this.$route.query.cakeOrderId ? '' : this.$route.query.orderId || '',
      },
      proList: [], // 产品名称筛选
      orderList: [], // 订单编号筛选
      deliveryList: [], // 发货列表
      amount: 0, // 发货数量
      total: 0,
      status: null,
      urls: [],
      statusList: [
        { label: $t('待发货'), value: 1 },
        { label: $t('下单失败'), value: 2 },
        { label: $t('已发货'), value: 3 },
        { label: $t('已取消'), value: 4 },
        { label: $t('需追回'), value: 5 },
        { label: $t('已追回'), value: 6 },
        { label: $t('已冻结'), value: 7 },
        { label: $t('已收货'), value: 8 },
      ],
    }
  },
  methods: {
    getStatus(status) {
      // eslint-disable-next-line eqeqeq
      return this.statusList.filter(item => item.value == status)
    },
    // 产品名称
    getProList() {
      const data = {
        productType: 2,
      }
      this.$ajax(this.$url.getproductList(), data).then(res => {
        this.proList = res.data || []
        if (this.search.proId === '') {
          this.search.proId = this.proList[0].productId
        }
        this.getCount()
        this.getList()
      })
    },
    // 订单编号
    getOrderList() {
      const data = {
        productType: 2,
      }
      this.$ajax(this.$url.getAvailableList(), data).then(res => {
        this.orderList = res.data || []
        this.searchList()
      })
    },
    // 发货列表
    getList() {
      const data = {
        gid: this.userInfo.gid,
        productId: this.search.proId,
        bizOrderId: this.$route.query.cakeOrderId ? this.$route.query.cakeOrderId : this.search.orderId,
        year: this.search.startTime.split('-')[0],
        month: this.search.startTime.split('-')[1],
        page: this.currentPage,
        pageSize: 10,
      }
      this.$ajax(this.$url.getDeliveryList(), data).then(res => {
        this.deliveryList = res.data.resultList || []
        this.total = res.data.totalItems || 0
        this.realTime = this.search.startTime
      })
    },
    // 获取发货数量
    getCount() {
      const data = {
        gid: this.userInfo.gid,
        productId: this.search.proId,
        bizOrderId: this.$route.query.cakeOrderId ? this.$route.query.cakeOrderId : this.search.orderId,
        year: this.search.startTime.split('-')[0],
        month: this.search.startTime.split('-')[1],
        page: this.currentPage,
        pageSize: 10,
      }
      this.$ajax(this.$url.deliveryCount(), data).then(res => {
        this.amount = res.data || 0
      })
    },
    // 查询
    searchList() {
      if (!this.search.proId) {
        return this.$message.error($t('请选择产品'))
      }
      this.currentPage = 1
      this.getList()
      this.getCount()
    },
    changePro() {
      this.search.orderId = ''
    },
    // 清空
    clear() {
      this.search.proId = ''
      this.search.orderId = ''
      this.searchList()
    },
    currentChange(val) {
      this.currentPage = val
      this.getList()
      this.getCount()
    },
    // 下载报告
    downLoad(url) {
      window.open(url)
    },
    // 导出发货记录
    recordExport() {
      const data = {
        gid: this.userInfo.gid,
        productId: this.search.proId,
        bizOrderId: this.$route.query.cakeOrderId ? this.$route.query.cakeOrderId : this.search.orderId,
        year: this.search.startTime.split('-')[0],
        month: this.search.startTime.split('-')[1],
        page: this.currentPage,
        pageSize: 10,
      }
      this.$ajax(this.$url.deliveryExport(), data).then(() => {
        this.dialogVisible = true
        this.getExportStatus(JSON.stringify(data))
      })
    },
    // 导出状态
    getExportStatus(searchData) {
      const data = JSON.parse(searchData)
      if (this.clock) clearInterval(this.clock)
      this.clock = setInterval(() => {
        this.$ajax(this.$url.exportDeliveryStatus(), data)
          .then(res => {
            this.status = res.data.status
            if (res.data.status === 1) {
              clearInterval(this.clock)
              this.urls = []
              res.data.urls.forEach(item => {
                const arr = item.split('?')[0].split('/')
                const name = decodeURI(arr[arr.length - 1])
                this.urls.push({
                  name,
                  url: item,
                  time: res.data.updateTime,
                })
              })
              if (
                res.data.updateTime + 60 * 60 * 24 * 1000 < +new Date() &&
                // eslint-disable-next-line eqeqeq
                data.month == new Date().getMonth() + 1 &&
                // eslint-disable-next-line eqeqeq
                data.year == new Date().getFullYear()
              ) {
                this.status = -1
              }
            } else if (res.data.status === 0) {
              this.time = data.month
            } else if (res.data.status === -1) {
              clearInterval(this.clock)
            }
          })
          .catch(() => {
            clearInterval(this.clock)
          })
      }, 1000)
    },
  },
  mounted() {
    this.getOrderList() // 订单编号
    this.getProList() // 产品名称
  },
}
</script>
<style lang="less" scoped>
/deep/ .es-col {
  word-break: break-all;
}
.page {
  text-align: right;
  margin: 20px 0;
}
.load {
  img {
    width: 12px;
    height: 12px;
  }
  span {
    font-size: 14px;
  }
}
.dialogRow {
  margin-top: 10px;
}
.tip {
  font-weight: 900;
  color: #4b4b4bff;
  font-size: 14px;
  margin-bottom: 15px;
  .tip-button {
    margin-left: 15px;
  }
}

.table-main,
.table-title {
  min-height: 40px;
  line-height: 40px;
  color: #1c1c1cff;
  font-weight: 500;
  border-top: 1px solid RGBA(243, 243, 243, 1);
  text-align: left;
  padding-left: 20px;
  background: #f7f8faff;
  display: flex;
  align-items: center;
  :last-child {
    text-align: center;
  }
}
.downLoadBtn {
  margin-left: 20px;
}
.table-title {
  font-weight: 600;
  background-color: #fafafa;
}
.table-main {
  min-height: 50px;
  line-height: 50px;
  background: #fff;
  border: 1px solid RGBA(236, 241, 246, 1);
  border-top: none;
}
.width150 {
  max-width: 150px;
}
.search-bar {
  .es-row {
    width: 100%;
  }
  .es-col {
    height: 56px;
    display: flex;
    align-items: center;
  }
}
</style>
